export const columns = [
  {
    title: '险种名称',
    key: 'name',
    tree: true,
    align: 'left',
    width: 400,
    render(h, params) {
      const level = params.row.level;
      let value = '';
      function numberTransform(num) {
        var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];
        if (!num || isNaN(num)) return '零';
        var english = num.toString().split('');
        var result = '';
        for (var i = 0; i < english.length; i++) {
          var des_i = english.length - 1 - i; // 倒序排列设值
          result = arr2[i] + result;
          var arr1_index = english[des_i];
          result = arr1[arr1_index] + result;
        }
        result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十'); // 将【零千、零百】换成【零】 【十零】换成【十】
        result = result.replace(/零+/g, '零'); // 合并中间多个零为一个零
        result = result.replace(/零亿/g, '亿').replace(/零万/g, '万'); // 将【零亿】换成【亿】【零万】换成【万】
        result = result.replace(/亿万/g, '亿'); // 将【亿万】换成【亿】
        result = result.replace(/零+$/, ''); // 移除末尾的零
        result = result.replace(/^一十/g, '十'); // 将【一十】换成【十】
        return `(${result})`;
      }

      value = `${level == 2 ? params.row._index + 1 : ''}${level == 3 ? numberTransform(params.row._index + 1) : ''}${
        level == 4 ? params.row._index + 1 + '、' : ''
      } ${params.row.name}`;
      return <span style={{ fontWeight: level == 2 ? 'bold' : '', marginLeft: '10px' }}>{value}</span>;
    }
  },
  {
    title: '保费金额',
    align: 'center',
    children: [
      {
        title: '累计',
        key: 'annual_firstFee',
        align: 'center',
        minWidth: 130,
        render(h, params) {
          return <span>{params.row.annual_firstFee ? params.row.annual_firstFee : '0.00'}</span>;
        }
      }
    ]
  },
  {
    title: '应付保费',
    align: 'center',
    children: [
      {
        title: '累计',
        key: 'annual_payable',
        align: 'center',
        minWidth: 130,
        render(h, params) {
          return <span>{params.row.annual_payable ? params.row.annual_payable : '0.00'}</span>;
        }
      }
    ]
  },
  {
    title: '经纪费用',
    align: 'center',
    children: [
      {
        title: '累计',
        key: 'annual_firstCommissionPrice',
        align: 'center',
        minWidth: 90,
        render(h, params) {
          return <span>{params.row.annual_firstCommissionPrice ? params.row.annual_firstCommissionPrice : '0.00'}</span>;
        }
      }
    ]
  },
  {
    title: '其中自营网络平台渠道',
    align: 'center',
    children: [
      {
        title: '保费金额',
        key: 'selfSupport_firstFee',
        align: 'center',
        minWidth: 130,
        render(h, params) {
          return <span>{params.row.selfSupport_firstFee ? params.row.selfSupport_firstFee : '0.00'}</span>;
        }
      },
      {
        title: '经纪费用',
        key: 'selfSupport_firstCommissionPrice',
        align: 'center',
        minWidth: 130,
        render(h, params) {
          return <span>{params.row.selfSupport_firstCommissionPrice ? params.row.selfSupport_firstCommissionPrice : '0.00'}</span>;
        }
      }
    ]
  },
  {
    title: '其中第三方网络平台渠道',
    align: 'center',
    children: [
      {
        title: '保费金额',
        key: 'thirdParty_firstFee',
        align: 'center',
        minWidth: 130,
        render(h, params) {
          return <span>{params.row.thirdParty_firstFee ? params.row.thirdParty_firstFee : '0.00'}</span>;
        }
      },
      {
        title: '经纪费用',
        key: 'thirdParty_firstCommissionPrice',
        align: 'center',
        minWidth: 130,
        render(h, params) {
          return <span>{params.row.thirdParty_firstCommissionPrice ? params.row.thirdParty_firstCommissionPrice : '0.00'}</span>;
        }
      }
    ]
  }
];
